module.exports = __webpack_public_path__ + "img/XU.1f602451.png";